var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_7333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8629 8.99825L6.86364 1.99953C6.77644 1.84566 6.64998 1.71768 6.49717 1.62863C6.34436 1.53959 6.17066 1.49268 5.9938 1.49268C5.81694 1.49268 5.64325 1.53959 5.49043 1.62863C5.33762 1.71768 5.21116 1.84566 5.12396 1.99953L1.1247 8.99825C1.03655 9.1509 0.990335 9.32414 0.990725 9.50041C0.991115 9.67668 1.0381 9.84972 1.12692 10.002C1.21574 10.1542 1.34323 10.2803 1.49648 10.3674C1.64972 10.4545 1.82327 10.4996 1.99954 10.498H9.99807C10.1735 10.4978 10.3458 10.4515 10.4976 10.3636C10.6495 10.2758 10.7755 10.1496 10.8632 9.99762C10.9508 9.84566 10.9969 9.67332 10.9969 9.4979C10.9968 9.32248 10.9506 9.15016 10.8629 8.99825Z",
    stroke: "#E7000B",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 4.49927V6.4989",
    stroke: "#E7000B",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 8.49854H6.00402",
    stroke: "#E7000B",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_7333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9978,
    height: 11.9978,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerError);
export default __webpack_public_path__ + "static/media/danger_error.32eb3620dd34d82601e0e5515c4e22c5.svg";
export { ForwardRef as ReactComponent };